import { apiClient } from '../apiClient';

/**
 * Helper to extract company slug from current URL path
 * CRITICAL: Returns empty string if company not found to prevent malformed URLs
 */
const getCompanySlug = (): string => {
  if (typeof window === 'undefined') return '';
  const parts = window.location.pathname.split('/').filter(Boolean);
  const company = parts[0] || '';
  
  // CRITICAL FIX: Validate company slug to prevent empty/malformed URLs
  // Empty company would result in /api//rpc/clients/list which causes 404
  if (!company || company === 'undefined' || company.trim() === '') {
    console.warn('[rpcTasks] Company slug is empty or invalid:', {
      pathname: window.location.pathname,
      parts,
    });
    return '';
  }
  
  return company;
};

/**
 * Build RPC endpoint URL
 * CRITICAL: Validates company before building URL to prevent 404s
 */
const buildUrl = (path: string): string => {
  const company = getCompanySlug();
  
  // CRITICAL FIX: Prevent API calls with empty company (would cause 404)
  if (!company) {
    const error = new Error('Company slug is required but not available. Please ensure you are on a valid company page.');
    console.error('[rpcTasks] buildUrl failed:', error.message, {
      pathname: window.location.pathname,
    });
    throw error; // Throw error to prevent malformed request
  }
  
  return `/api/${company}/rpc/clients${path}`;
};

/**
 * RPC client for task-related operations
 * All endpoints return { ok: true, data } or { ok: false, error }
 */
const rpcTasks = {
  /**
   * Get client reminders
   */
  getClientReminders(clientId: string) {
    return apiClient.post(buildUrl('/get-client-reminders'), { clientId });
  },

  /**
   * Get tasks by client
   */
  getTasksByClient(clientId: string, params?: { rolePrefix?: 'admin' | 'manager' }) {
    return apiClient.post(buildUrl('/get-tasks-by-client'), { clientId, ...params });
  },

  /**
   * Get admin tasks by client
   */
  getAdminTasksByClient(clientId: string, params?: any) {
    return apiClient.post(buildUrl('/get-admin-tasks-by-client'), { clientId, ...params });
  },
};

export default rpcTasks;

